var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.loaded
        ? _c(
            "DIV",
            { staticClass: "col-4" },
            [
              _c("ItpFormInput", {
                attrs: {
                  mask: "number",
                  unmask: "typed",
                  scale: _vm.scale,
                  name: _vm.name + "__amount",
                  readonly: _vm.readonly
                },
                on: {
                  input: function($event) {
                    return _vm.evh_2248226175642056_input($event, {})
                  }
                },
                model: {
                  value: _vm.internalValue.amount,
                  callback: function($$v) {
                    _vm.$set(_vm.internalValue, "amount", $$v)
                  },
                  expression: "internalValue.amount"
                }
              })
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.loaded
        ? _c(
            "DIV",
            { staticClass: "col-3" },
            [
              _c("CurrencySelector", {
                attrs: {
                  name: _vm.name + "__currency",
                  item: _vm.internalValue,
                  path: "currency",
                  readonly: _vm.readonly
                },
                on: {
                  input: function($event) {
                    return _vm.evh_96700093353179_input($event, {})
                  }
                }
              })
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }